import GridContainer from "../../Componant/Ui Kit/Grid";

const Grid = () => {
  return (
    <div className="page-body">
      <GridContainer />
    </div>
  );
};

export default Grid;
